import Swiper from 'swiper/bundle';
import 'swiper/css';

(function ($) {
    $('.section-our-leaders').each(function () {
        const $this = $(this);
        const $slider = $this.find('.our-leaders-slider');
        const $next = $this.find('.swiper-button-next');
        const $prev = $this.find('.swiper-button-prev');

        new Swiper($slider[0], {
            slidesPerView: 'auto',
            spaceBetween: 11,
            navigation: {
                nextEl: $next[0],
                prevEl: $prev[0],
            }
        });
    });
})(jQuery);